import { computed } from 'vue';
import useRwdImg from '@/hooks/useRwdImg';

const rouletteDownArrow = computed(() => useRwdImg('home_pc_roulette_down_arrow', false));
const arrowActive = computed(() => useRwdImg('home_pc_milestones_arrow_active', false));
const playButtonActive = computed(() => useRwdImg('home_pc_play_active', false));
const timeLeftArrowActive = computed(() => useRwdImg('home_pc_time_left_arrow_active', false));
const timeRightArrowActive = computed(() => useRwdImg('home_pc_time_right_arrow_active', false));

export function useImgSrc() {
  return {
    rouletteDownArrow: rouletteDownArrow.value.imgSrc,
    arrowActive: arrowActive.value.imgSrc,
    playButtonActive: playButtonActive.value.imgSrc,
    timeLeftArrowActive: timeLeftArrowActive.value.imgSrc,
    timeRightArrowActive: timeRightArrowActive.value.imgSrc,
  }
}
